import { useState } from 'react';

import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Image, Modal, ModalProps, Typography, Form, Input } from 'antd';

interface Props extends ModalProps {
  onComplete?: (barobillId: string) => void;
}

const LoginInfoConfirmModal: React.FC<Props> = ({ ...props }) => {
  const [form] = Form.useForm();

  const [submittable, setSubmittable] = useState(false);

  const onFinish = (values: { barobillId: string }) => {
    // 아이디 입력 후 연동 완료 후 호출
    props.onComplete?.(values.barobillId);
  };

  const valueForCheck = Form.useWatch([], form);

  return (
    <Modal
      open={props.open}
      onCancel={props.onCancel}
      closable
      cancelText="이전"
      okText="연동하기"
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        disabled: !valueForCheck?.barobillId,
      }}
    >
      <Flex
        gap={24}
        style={{
          padding: '8px 24px 12px 24px',
        }}
        justify="center"
        align="center"
        direction="column"
      >
        <Flex align="center">
          <Image
            alt="barobill-icon"
            src="https://static.clobe.ai/image/clobe-logo-dark-icon.png"
            width={24}
            height={24}
            style={{
              height: 24,
            }}
          />
          <span style={{ color: colorTokens.textDescription }}>..........</span>
          <Image
            alt="barobill-icon"
            src="https://static.clobe.ai/image/barobill-icon.png"
            width={28}
            height={28}
            style={{
              height: 28,
            }}
          />
        </Flex>
        <Flex direction="column" gap={4} align="center">
          <Typography.Title level={5}>
            바로빌에 로그인할 때 사용하는 아이디를 입력해 주세요.
          </Typography.Title>
        </Flex>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{
            width: '100%',
          }}
        >
          <Form.Item name="barobillId" label="바로빌 아이디" required>
            <Input placeholder="바로빌 아이디를 입력해주세요." />
          </Form.Item>
        </Form>
      </Flex>
    </Modal>
  );
};

export default LoginInfoConfirmModal;
